import { Theme } from '@mui/material';

const styles = {
  toolbarBtn: {
    p: 1,
    width: '1.75rem',
    height: '1.75rem',
    padding: 0.25,
    borderRadius: '0.25rem',
    margin: 0.25,
    border: '1px solid black',
    '&.Mui-disabled': {
      color: 'grey',
      backgroundColor: '#D3D3D3'
    },
    '& svg': {
      width: '1rem'
    }
  },
  linkModalStyles: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -0%)',
    background: '#FFF',
    display: 'flex',
    height: 'fit-content',
    width: '300px',
    padding: 2,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: 2,
    boxShadow: 24,
    '.MuiModal-backdrop': {
      backgroundColor: '#FFF',
      borderRadius: 2
    }
  },
  linkModalButtonStyles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2
  },
  linkModalAddButton: {
    backgroundColor: (theme: Theme): string => theme.palette.brand.main,
    '&:hover': {
      backgroundColor: (theme: Theme): string => theme.palette.brand.main
    }
  },
  linkModalCancelButton: {
    backgroundColor: (theme: Theme): string => theme.palette.brand.secondary,
    '&:hover': {
      backgroundColor: (theme: Theme): string => theme.palette.brand.secondary
    },
    color: 'black'
  }
};

export default styles;
